import { render, staticRenderFns } from "./ClaimOverviewTab.vue?vue&type=template&id=5489efc6"
import script from "./ClaimOverviewTab.vue?vue&type=script&lang=js"
export * from "./ClaimOverviewTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports